/**
 * Stepper — generic horizontal milestone strip.
 *
 * Used by TrackingPanel and reusable elsewhere. Each milestone is one
 * of: done | current | pending. Colors itself accordingly.
 */
import React from 'react';
import { Check } from 'lucide-react';

const Stepper = ({ steps }) => {
  // steps: [{ key, label, ts, done }]
  // Treats the first non-done as 'current'.
  let currentIdx = steps.findIndex((s) => !s.done);
  if (currentIdx < 0) currentIdx = steps.length; // all done

  return (
    <div className="manifest-stepper">
      {steps.map((s, i) => {
        const status = s.done ? 'done' : i === currentIdx ? 'current' : 'pending';
        return (
          <React.Fragment key={s.key || i}>
            <div className={`manifest-stepper-node status-${status}`}>
              <div className="manifest-stepper-circle">
                {s.done ? <Check size={14} /> : i + 1}
              </div>
              <div className="manifest-stepper-label">{s.label}</div>
              {s.ts && <div className="manifest-stepper-ts">{new Date(s.ts).toLocaleDateString('en-CA', { month: 'short', day: 'numeric' })}</div>}
            </div>
            {i < steps.length - 1 && (
              <div className={`manifest-stepper-bar ${s.done ? 'done' : 'pending'}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Stepper;
